<template>
  <div>
    <div class="content-box">
      <div class="content-box-title">
        <div>广告数据报表</div>
        <div class="content-box-title-right-form">
          <p v-if="isShowSelect">
            <el-select v-model="model.showType" placeholder="请选择" style="margin-right:10px" size="small">
              <el-option
                v-for="item in selectType === 1 ? seeTypeOptions0 : seeTypeOptions2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </p>
          <p v-if="isShowTimePicker && model.showType !== 6">
            <el-date-picker
              size="small"
              class="form-time-picker"
              v-model="searchData.time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              :clearable="selectType !== 1"
              @input="handleDateChange"
            ></el-date-picker>
          </p>
        </div>
      </div>
      <div class="content-select">
        <el-form class="demo-rule-form" size="small">
          <div class="select-box">
            <el-form-item label="项目订单">
              <div class="select-box-form-button" @click="dialogTableVisible = !dialogTableVisible">
                <p class="select-box-form-button_title">{{this.searchData.currentOrderName}}</p>
                <!-- <p class="select-box-form-button_text">选择</p> -->
                <el-button type="text" style="padding-right:5px">选择</el-button>
              </div>
            </el-form-item>
            <el-form-item label="投放计划" v-if="activeName !== 'resultsData'">
              <el-select v-model="model.scheduleId" filterable clearable placeholder="请选择">
                <el-option v-for="item in searchData.scheduleOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="素材创意" v-if="activeName !== 'frequencyData'">
              <el-select v-model="model.mediaId" filterable clearable placeholder="请选择">
                <el-option v-for="item in searchData.mediaOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div>
          <el-button size="small" type="primary" @click="handleChartsFilter">筛选</el-button>
          <el-button size="small" @click="handleClearSelect">重置</el-button>
        </div>
      </div>
      <div :class=" ['audienceData', 'frequencyData'].includes(activeName)?'no-gap':''">
        <el-tabs :value="activeName" @input="handleChangeRouter" :class="isMounted ? 'table-tabs': 'table-tabs table-tabs--before-mount'">
          <el-tab-pane label="基础数据" name="orderBasicData">
            <span slot="label" @click.stop="handleChangeRouter('orderBasicData')">基础数据</span>
            <slot name="orderBasicData"></slot>
          </el-tab-pane>
          <el-tab-pane label="地域数据" name="areaData">
            <span slot="label" @click.stop="handleChangeRouter('areaData')">地域数据</span>
            <slot name="areaData"></slot>
          </el-tab-pane>
          <el-tab-pane label="受众人群" name="audienceData">
            <span slot="audienceData" @click.stop="handleChangeRouter('audienceData')">地域数据</span>
            <slot name="audienceData"></slot>
          </el-tab-pane>
          <el-tab-pane label="频次到达" name="frequencyData">
            <span slot="frequencyData" @click.stop="handleChangeRouter('frequencyData')">频次到达</span>
            <slot name="frequencyData"></slot>
          </el-tab-pane>
<!--          <el-tab-pane label="效果数据" name="resultsData">-->
<!--            <span slot="resultsData" @click.stop="handleChangeRouter('resultsData')">效果数据</span>-->
<!--            <slot name="resultsData"></slot>-->
<!--          </el-tab-pane>-->
        </el-tabs>
      </div>
    </div>
    <!--订单选择-->
    <el-dialog :visible.sync="dialogTableVisible" :show-close="false" width="50%">
      <!--这里要封装成组件-->
      <div style="margin-bottom:16px">
        <el-input v-model="orderName" placeholder="输入订单名称查询" @input="handleSearchOrder" />
      </div>
      <Table :props="table.props" :header="table.header" :data="table.data" :select-on-row-click="true" />
      <pagination
        v-bind:currentpage="currentPage"
        v-bind:pagesize="pageSize"
        v-bind:totalcount="totalCount"
        @handle-size-change="handleSizeChange"
        @handle-current-change="handleCurrentChange"
      ></pagination>
    </el-dialog>
    <!---->
  </div>
</template>
<script>
export default {
  inject: ['searchData'],
  data() {
    return {
      isMounted: false,
      seeTypeOptions0: [
        {
          value: 0,
          label: '分天展示'
        },
        {
          value: 1,
          label: '分小时展示'
        }
      ],
      seeTypeOptions1: [
        {
          value: 0,
          label: '每日数据'
        },
        {
          value: 1,
          label: '截止昨日数据'
        }
      ],
      seeTypeOptions2: [
        {
          value: 0,
          label: '分天展示'
        },
        {
          value: 6,
          label: '合计'
        },
        {
          value: 1,
          label: '按自然周'
        },
        {
          value: 2,
          label: '按自然月'
        }
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      // 订单查询页
      pageSize: 10,
      // 当前页码:pageNum
      currentPage: 1,
      totalCount: 1,
      // 查询的页码
      start: 1,
      filter: {},
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '订单名称',
            align: 'left',
            prop: 'orderName',
            'show-overflow-tooltip': true,
            'min-width': '180',
            render: (h, { row }) => {
              return h(
                'span',
                {
                  style: {
                    color: '#169bd5',
                    // 'border-bottom': '1px solid #169bd5',
                    cursor: 'pointer'
                  },
                  on: {
                    click: () => {
                      this.handleSelectOrder(row)
                    }
                  }
                },
                row.orderName
              )
            }
          },
          {
            label: '状态',
            align: 'left',
            prop: 'orderStatus',
            'show-overflow-tooltip': true,
            'min-width': '110',
            render: (h, { row }) => {
              switch (row.orderStatus) {
                case 0:
                  return '启用中'
                case 1:
                  return '已结束'
                case 2:
                  return '暂停'
                case 3:
                  return '待确认结算'
                case 4:
                  return '已到期'
                default:
                  return '已删除'
              }
            }
          },
          {
            label: '曝光量（pv）',
            align: 'right',
            prop: 'oSendAmount',
            'show-overflow-tooltip': true,
            'min-width': '110',
            formatter: (params) => {
              return (params.oSendAmount || 0).toLocaleString()
            }
          }
        ],
        data: []
      },
      dialogTableVisible: false,
      orderName: '',
      timer: null
    }
  },
  watch: {
    'model.scheduleId'(val) {
      if (val) {
        this.model.scheduleNo = this.searchData.scheduleOptions.find(item => item.value === val).scheduleNo
      }
    }
  },
  props: ['selectTabsType'],
  computed: {
    model() {
      return this.searchData.model
    },
    activeName() {
      let activeName = 'orderBasicData'
      if (this.selectTabsType === 'areaData') {
        activeName = 'areaData'
      } else if (this.selectTabsType === 'audienceData') {
        activeName = 'audienceData'
      } else if (this.selectTabsType === 'frequencyData') {
        activeName = 'frequencyData'
      } else if (this.selectTabsType === 'resultsData') {
        activeName = 'resultsData'
      }
      return activeName
    },
    selectType() {
      let type = 0
      if (this.selectTabsType === 'orderBasicData') {
        type = 1
      }
      return type
    },
    isShowSelect() {
      let show = false
      if (this.selectTabsType === 'orderBasicData' || this.selectTabsType === 'frequencyData') {
        show = true
      }
      return show
    },
    isShowTimePicker() {
      let show = true
      if (
        this.selectTabsType === 'resultsData'
      ) {
        show = false
      }
      return show
    }
  },
  methods: {
    handleDateChange(val) {
      if (val && val[0]) {
        val = [this.$moment(val[0]).format(
          'YYYY-MM-DD'
        ), this.$moment(val[1]).format(
          'YYYY-MM-DD'
        )]
        const length = this.$moment(val[1]).diff(this.$moment(val[0]), 'days')
        if (length > 30 && this.model.showType === 0 && this.activeName === 'frequencyData') {
          this.searchData.time = []
          this.$message.error('时间跨度不允许超过30天')
        } else {
          this.searchData.time = val
        }
      } else {
        this.searchData.time = []
      }
    },
    fetchData() {
      this.filter.pageNo = this.currentPage
      this.filter.pageSize = this.pageSize
      return this.$service.getOrderList(this.filter).then((data) => {
        this.table.data = data.rows
        this.totalCount = data.total
        return data
      })
    },
    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange: function (val) {
      this.pageSize = val
      this.fetchData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleFilterChange(type) {},
    handleFilterReset() {},
    // 通过订单名搜索订单
    handleSearchOrder(val) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        if (val) {
          this.orderName = val
          this.filter.orderName = val
          this.currentPage = 1
          this.fetchData()
        } else {
          this.orderName = ''
          this.filter.orderName = ''
          this.fetchData()
        }
      }, 200)
    },
    // 选择订单
    handleSelectOrder(row) {
      // 清空计划、素材的ID
      const model = this.model || {}
      model.scheduleId = undefined
      model.mediaId = undefined
      model.orderId = row.orderId
      model.orderNo = row.orderNo
      this.searchData.currentOrderName = row.orderName
      // model.beginDate = row.contractBeginDate || new Date()
      model.beginDate = this.$moment().subtract(30, 'days').format('YYYY-MM-DD')
      model.endDate = row.contractEndDate || new Date()
      this.searchData.currentOrderName = row.orderName
      this.searchData.time = [model.beginDate, new Date()]
      // 查询，填充选项
      const orderId = row.orderId
      // 没有订单
      if (!orderId) {
        return
      }
      this.$service.getScheduleByOrderId({ orderId }).then((data) => {
        this.searchData.scheduleOptions = data.map((item) => {
          return { label: item.scheduleName, value: item.scheduleId, scheduleNo: item.scheduleNo }
        })
      })
      this.$service.getMediasByOrderId(orderId).then((data) => {
        this.searchData.mediaOptions = data.map((item) => {
          return { label: item.mediaName, value: item.mediaId }
        })
      })
      this.dialogTableVisible = false
    },
    handleClearSelect() {
      this.isFilter = false
      this.searchData.currentOrderName = ''
      this.searchData.model.orderId = ''
      this.searchData.model.scheduleId = ''
      this.searchData.model.mediaId = ''
      this.searchData.model.showType = 0
      // this.searchData.model.time = [new Date(), new Date()]
      this.searchData.model.time = [this.$moment().subtract(30, 'days').format('YYYY-MM-DD'), new Date()]
      this.searchData.scheduleOptions = []
      this.searchData.mediaOptions = []
      // this.$EventBus.$emit('clear-filter');
      // this.$emit('clear-filter')
    },
    handleChangeRouter(val) {
      if (val === 'frequencyData' || val === 'orderBasicData') {
        this.model.showType = 0
      }
      if (val === 'frequencyData') {
        this.searchData.time = [this.$moment().subtract(30, 'days').format('YYYY-MM-DD'), new Date()]
      }
      this.$router.push({ name: val })
    },
    handleChartsFilter() {
      if (this.selectType !== 1) {
        this.searchData.isFilter = true
        this.$emit('event-filter', this.searchData)
        return
      }
      if (this.searchData.time) {
        this.searchData.isFilter = true
        this.$emit('event-filter', this.searchData)
      }
    }
  },
  mounted() {
    this.isMounted = true
  },
  created() {
    if (this.$route.params.order) {
      const order = this.$route.params.order
      this.searchData.model.orderId = order.orderId
      this.searchData.currentOrderName = order.orderName
      this.searchData.isFilter = true
      this.handleSelectOrder(order)
    }
    this.fetchData()
  }
}
</script>
<style lang="stylus" scoped>
>>>.el-tabs__nav-wrap::after
  display none
.content-box-title
  padding 24px 32px 20px 32px
  height 28px
  font-size 20px
  font-weight 500
  color rgba(0, 0, 0, 0.85)
  line-height 28px
  font-size 20px
  display flex
  flex-direction row
  align-items center
  justify-content space-between
  border-bottom 1px solid #e9e9e9
  background-color #fff
.content-box-title-right-form
  display flex
.content-box-title-right-form .form-time-picker
  width 100%
.content-select
  padding 30px 32px 0
  display flex
  background-color #fff
  justify-content space-between
.no-gap  .table-tabs {
  >>> .el-tabs__header {
    margin-bottom 2px
  }
}
.table-tabs
  // margin 22px 0 16px 32px
  >>>.el-tabs__item
    padding 0
    color rgba(0, 0, 0, 0.65)
    width 128px
    text-align center
    padding-right 32px !important
  >>>.el-tabs__item.is-active, >>>.el-tabs__item :hover
    color #FF8B00
  >>>.el-tabs__item span
    display block
    width 96px
  >>>.el-tabs__active-bar
    width 96px !important
  >>> .el-tabs__header
    margin 0
    background #fff
    margin-bottom 16px
    padding 22px 32px 0px
p
  margin 0px
.chart-title, .download
  display flex
  justify-content space-between
  padding-right 20px
.header-select
  display flex
  flex-direction row
.header-select p:first-child
  margin-right 16px
>>>.el-button span
  display flex
  flex-direction row
.select-box-form-button
  border 1px solid #DCDFE6
  border-radius 4px
  box-sizing border-box
  display flex
  align-items center
  justify-content space-between
  cursor pointer
  height 32px
.select-box-form-button_title
  display block
  overflow hidden
  text-overflow ellipsis
  white-space nowrap
  text-align left
  padding-left 15px
  color #606266
.select-box-form-button_text
  margin-right 15px
  color #1890FF
>>>.el-form-item__content .el-select
  display flex
>>>.el-form--inline .el-form-item
  margin-right 40px
>>>.el-divider--vertical
  height 50px
.content-select >>>.el-form-item
  margin-bottom 0
  width 31%
  margin-right 3%
.content-select >>>.el-form-item:last-child
  margin-right 0
.exposure-data.content-list
  margin-top 0
.select-data
  font-size 16px
  line-height 34px
.title-right
  text-indent 0
.right-date
  display flex
  justify-content flex-end
.demo-rule-form
  width 85%
.select-box
  width 100%
  display flex
  flex-direction row
  flex-wrap wrap
</style>
